import React from 'react'
import { styled } from 'styled-components'
import { Link } from 'react-router-dom'

const SocietyRoleInfo = () => {

    const roleInfo = [{title:'Academic excellence',description:'Striving for academic brilliance through rigorous programs and dedicated faculty, fostering future engineering leaders.'},{
        title:"Extended impact",description:"Empowering women, fostering industry partnerships, and engaging communities for far-reaching influence and transformative advancement."},
        {title:"Research advancements",description:"Pioneering discoveries at the forefront of innovation, driving progress and transforming engineering possibilities."}] 

  return (
    <Container className='society-role-info'>
    <h2>One Society, Infinite Possibilities</h2>
    <div className="role-info-container">
        {roleInfo.map((role,index)=>{
            return(
                <div className="role-info" key={index}>
                    <h4>{role.title}</h4>
                    <p>{role.description}</p>
                </div>
            )
        })}
    </div>
    <Link to="/signup"><button className='get-started-btn'>Get Started</button></Link>
</Container>
  )
}

const Container = styled.section`
    margin: 5em 0;
    padding:0 2em;
    text-align: center;
    h2{
        font-size: 3rem;
        margin-bottom: 1em;
    }
    .role-info{
        border-top:1px solid var(--color-muted-black);
        h4{
            font-size: 1.5rem;
            margin-bottom: 0.5em;
        }
        p{
            padding: 0.5em 5em;
            letter-spacing: 1px;
        }
    }
    .get-started-btn{
        background-color: var(--color-black);
        color: var(--color-white);
        font-size: 1.2rem;
        font-weight: 400;
        border-radius: 50px;
        padding: 0.7em 2em;
        border: none;
        line-height: 21px;
        margin:1em 0;
        cursor: pointer;
        &:hover{
            background-color: var(--primary-color);
        }
    }
    
    @media only screen and (min-width: 800px) {
        padding: 0 5em;
        text-align: unset;
        .role-info-container{
            display: flex;
            gap: 3em;
            .role-info{
                padding: 0.5em 1em;
                text-align: left;
                p{  
                    line-height: 1.7;
                    font-size: 1.2rem;
                    padding: 0.5em 0;
                }
                h4{
                    height: 4rem;
                }
            }
        }
    }

    @media only screen and (min-width: 1250px) {
        .role-info-container {
            .role-info {
                h4 {
                    height: 2rem;
                }
            }
        }
    }

    @media only screen and (min-width: 1400px) {
        padding: 0 20em;
        .role-info-container {
            .role-info {
                h4 {
                    height: 4rem;
                }
            }
        }
    }
`;


export default SocietyRoleInfo
